module.exports = __webpack_public_path__ + "assets/img/Ic-Pop.ee3efca8.png";